import axios from 'axios';

// API URL - environment variable'dan oku, yoksa '/api' kullan
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

// Export API_BASE_URL for use in other files
export const getApiBaseUrl = () => API_BASE_URL;

/**
 * Axios instance for API calls
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000 // 30 seconds
});

/**
 * Request interceptor - Add auth token
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor - Handle errors and token expiry
 */
apiClient.interceptors.response.use(
  (response) => {
    // Return the data directly for cleaner API calls
    return response.data;
  },
  (error) => {
    // Axios error objesi - response varsa, backend'den gelen hata mesajı
    const errorResponse = error.response?.data;
    
    // Handle 401 Unauthorized - token expired or invalid
    // SADECE token gerektiren endpoint'lerde yönlendir, login sayfasında DEĞİL
    if (error.response?.status === 401) {
      const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                             error.config?.url?.includes('/auth/customer-login');
      
      // Auth endpoint'lerinde 401 alındığında yönlendirme yapma
      // Sadece hata mesajını döndür
      if (!isAuthEndpoint) {
        // Clear local storage only for non-auth endpoints
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('customer_token');
        localStorage.removeItem('customer');
        
        // Redirect to login if not already there
        if (window.location.pathname !== '/login' && 
            window.location.pathname !== '/customer-login') {
          window.location.href = '/login';
        }
      }
    }

    // Return error response data for proper error handling
    // errorResponse varsa (backend'den gelen hata), onu döndür
    // yoksa genel axios hatasını döndür
    return Promise.reject(errorResponse || { 
      success: false, 
      error: error.message || 'Network error' 
    });
  }
);

/**
 * Helper function to handle API errors
 */
export const handleApiError = (error) => {
  if (error?.error) {
    return error.error;
  }
  if (error?.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};

/**
 * API Client Methods
 */
export const api = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
  patch: (url, data, config) => apiClient.patch(url, data, config)
};

export default apiClient;
